import {
    Avatar,
    Box,
    Center,
    Heading,
    HStack,
    SimpleGrid,
    Spinner,
    Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { fetchAllCouriers } from "../../api";

const CouriersNeedUpdate = () => {
    const [couriersNeedingUpdate, setCouriersNeedingUpdate] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getCouriers = async () => {
            setLoading(true);
            const response = await fetchAllCouriers(1, 999);
            if (response.success) {
                const filtered = response.data.couriers.filter(
                    (c) => c.appInfo?.appDetails?.carrier != '16.1'
                );
                setCouriersNeedingUpdate(filtered);
            }
            setLoading(false);
        };
        getCouriers();
    }, []);

    if (loading) return <Spinner size="md" />;

    return (
        <Box borderWidth="1px" borderRadius="lg" p={4} shadow="md">
            <Heading size="md" mb={4}>
                🔄 Couriers Need App Update
            </Heading>
            {couriersNeedingUpdate.length === 0 ? (
                <Center py={8}>
                    <Text fontSize="lg" color="green.500" fontWeight="bold">
                        All Good
                    </Text>
                </Center>
            ) : (
                <>
                    <Text mb={4}>
                        These couriers need to update their app to the latest version, <b>Current Appstore Version 16.1</b>
                    </Text>
                    <SimpleGrid columns={{ base: 2, md: 3, lg: 4 }} spacing={4}>
                        {couriersNeedingUpdate.map((c) => (
                            <Box
                                key={c._id}
                                p={2}
                                borderWidth="1px"
                                borderRadius="lg"
                                shadow="sm"
                            >
                                <HStack spacing={4}>
                                    <Avatar name={c.name} size="sm" />
                                    <Box>
                                        <Text fontWeight="bold">{c.name}</Text>
                                        <Text fontSize="xs" color="gray.500">
                                            {(c.appInfo?.appDetails?.model || "N/A") +
                                                " - " +
                                                (c.appInfo?.appDetails?.systemName || "N/A") +
                                                " - App V." +
                                                (c.appInfo?.appDetails?.carrier || "N/A")}
                                        </Text>
                                    </Box>
                                </HStack>
                            </Box>
                        ))}
                    </SimpleGrid>
                </>
            )}
        </Box>
    );
};

export default CouriersNeedUpdate;
